import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getNotice({params}) {
  console.log('sagagetNotice')
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_NOTIFICATION, {params})
    );
    yield put(actionCreators.getNoticeSuccess({
      type: params.type,
      data: response.data
    }));
    
    if (response.ok) {
      const { data } = response.data.body;
     
    }
  } catch (error) {
    
  }
}

function* getNoticeDetail({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_NOTIFICATION + '?id' + params.id)
    );
    yield put(actionCreators.getNoticeDetailSuccess({
      type: params.type,
      data: response.data
    }));
    
    if (response.ok) {
      const { data } = response.data.body;
     
    }
  } catch (error) {
    
  }
}


function* notice() {
  yield takeLatest(actionTypes.GET_NOTICE, getNotice);
  yield takeLatest(actionTypes.GET_NOTICE_DETAIL, getNoticeDetail);
}

export default notice;
